module.exports = __webpack_public_path__ + "img/tel.85404bd2.svg";